exports.list = {
    path: '/laporan_pemasukan_equipment',
    name: 'laporan_pemasukan_equipment_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_pemasukan_equipment/List.vue"),
}